import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default class ListItem extends Component {
  static propTypes = {
    onRemove: PropTypes.func
  }

  render () {
    const {
      onRemove,
      connectDragSource, connectDragPreview, isDragging
    } = this.props

    return connectDragPreview(
      <div className={cn('list-item', {placeholder: isDragging})}>
        {connectDragSource(<div className='handle' />)}
        {this.props.children}
        <button type='button' className='ion-ios-minus-outline' onClick={onRemove} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/ListItem.js